/* eslint-disable */
import Tracker from '@travelata-libs/tracker';
import config from '@fr/config/appConfig'

let clientUuid = window.appConfig.clientUuid;

if(!clientUuid) {
	// TrackJS.track("No clientUuid provided!!");
}

let marketingClient = null;

try {
	marketingClient = new Tracker({
		config: config.marketingClientConfig,
		clientUuid: clientUuid
	});
} catch(err) {
	// TrackJS.track(err);
}

export default marketingClient;